import { render, staticRenderFns } from "./FullWidth.vue?vue&type=template&id=47f4716f&scoped=true&"
import script from "./FullWidth.vue?vue&type=script&lang=js&"
export * from "./FullWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f4716f",
  null
  
)

export default component.exports